"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpreedlyProvider = void 0;
const tokenization_provider_abstract_1 = require("../providers/tokenization-provider.abstract");
const spreedly_config_1 = require("../config/spreedly.config");
const error_types_contants_1 = require("../constants/error-types.contants");
const tokenization_providers_constants_1 = require("../constants/tokenization-providers.constants");
const credit_card_constants_1 = require("../constants/credit-card.constants");
const mappers_1 = require("../utils/mappers");
const is_spreedly_1 = require("../utils/is-spreedly");
const defaultStyles = 'width: 100%; height: 100%; padding: 0px;';
class SpreedlyProvider extends tokenization_provider_abstract_1.TokenizationProvider {
    init() {
        return new Promise((resolve, reject) => {
            this.dom
                .loadSpreedlyScript()
                .then(() => {
                this.initSpreedly();
                resolve();
            })
                .catch(() => reject());
        });
    }
    tokenizeCreditCard(options, email) {
        return new Promise((resolve, reject) => {
            this.getToken(email)
                .then(result => resolve(this.mapResponse(result.token, email)))
                .catch(error => reject(error));
        });
    }
    getBinInfo(email) {
        return new Promise((resolve, reject) => {
            this.getToken(email)
                .then(({ bin, lastFourDigits }) => resolve({
                bin,
                lastFourDigits
            }))
                .catch(error => reject(error));
        });
    }
    reset() {
        if (is_spreedly_1.isSpreedy()) {
            Spreedly.reload();
            this.clearForm();
        }
    }
    removeHandlers() {
        if (is_spreedly_1.isSpreedy()) {
            Spreedly.removeHandlers();
            this.eventBus.removeEventListener();
        }
    }
    initSpreedly() {
        if (is_spreedly_1.isSpreedy()) {
            Spreedly.init(this.isProduction ? spreedly_config_1.SpreedlyConfig.PROD : spreedly_config_1.SpreedlyConfig.DEV, {
                numberEl: this.cardNumber.elementId,
                cvvEl: this.cvv.elementId
            });
            this.initEvents();
        }
    }
    initEvents() {
        Spreedly.on('ready', () => {
            Spreedly.setFieldType('number', 'text');
            Spreedly.setNumberFormat('prettyFormat');
            Spreedly.transferFocus('number');
            Spreedly.setPlaceholder('number', this.cardNumber.placeholder);
            Spreedly.setPlaceholder('cvv', this.cvv.placeholder);
            Spreedly.setStyle('number', defaultStyles);
            Spreedly.setStyle('cvv', defaultStyles);
        });
        this.notifyChangeState();
        this.notifyCardType('default');
        this.createInputs();
        Spreedly.on('fieldEvent', (name, type, activeEl, inputProperties) => {
            switch (name) {
                case 'number':
                    if (type === 'input') {
                        this.tokenManagerState[this.cardNumber.name].isValid = inputProperties.validNumber;
                        this.tokenManagerState[this.cardNumber.name].error = inputProperties.validNumber
                            ? error_types_contants_1.ErrorTypes.EMPTY
                            : error_types_contants_1.ErrorTypes.INVALID_CARD_NUMBER;
                        this.notifyChangeState();
                        this.notifyCardType(inputProperties.cardType);
                    }
                    else if (type === 'focus') {
                        this.notifyFocusInElement(this.cardNumber.name);
                    }
                    else if (type === 'blur') {
                        this.notifyFocusOut();
                    }
                    break;
                case 'cvv':
                    if (type === 'input') {
                        this.tokenManagerState[this.cvv.name].isValid = inputProperties.validCvv;
                        this.tokenManagerState[this.cvv.name].error = inputProperties.validCvv ? error_types_contants_1.ErrorTypes.EMPTY : error_types_contants_1.ErrorTypes.INVALID_CVV;
                        this.notifyChangeState();
                    }
                    else if (type === 'focus') {
                        this.notifyFocusInElement(this.cvv.name);
                    }
                    else if (type === 'blur') {
                        this.notifyFocusOut();
                    }
                    break;
            }
        });
    }
    mapSpreedlyRequest(email) {
        const [month, year] = this.expirationDateInput.value.split(credit_card_constants_1.EXPIRATION_DATE_SEPARATOR);
        return {
            email,
            first_name: this.firstNameInput.value,
            last_name: this.lastNameInput.value,
            month: Number(month.trim()),
            year: Number(`${credit_card_constants_1.FIRST_TWO_DIGITS_OF_THE_CURRENT_CENTURY}${year.trim()}`),
        };
    }
    mapResponse(tokenResult, email) {
        const data = {
            credit_card_data: {
                payment_method_token: tokenResult,
                is_debit: !!this.isDebitInput ? this.isDebitInput.checked : false
            },
            tokenizer: tokenization_providers_constants_1.TokenizationProviders.SPREEDLY,
            email
        };
        if (this.documentValue && this.documentType && this.documentValueInput && this.documentTypeSelect) {
            data.document = {
                document_type_id: this.documentTypeSelect.value || '',
                document_value: this.documentValueInput.value || '',
            };
        }
        return data;
    }
    getToken(email) {
        return new Promise((resolve, reject) => {
            if (!this.isValidData()) {
                this.notifyChangeState();
                return reject(mappers_1.mapTokenizerErrorResponse('lib', { message: error_types_contants_1.ErrorTypes.NEED_FILL_ALL_FIELDS }, 0));
            }
            Spreedly.tokenizeCreditCard(this.mapSpreedlyRequest(email));
            Spreedly.on('paymentMethod', (token, paymentMethod) => resolve({
                token,
                lastFourDigits: paymentMethod.last_four_digits,
                bin: paymentMethod.first_six_digits
            }));
            Spreedly.on('errors', (errors) => reject(mappers_1.mapTokenizerErrorResponse('provider', errors, 400)));
        });
    }
}
exports.SpreedlyProvider = SpreedlyProvider;
